import React, { useEffect, useState } from "react";
import { backend, blogurl, categoryurl, producturl } from "../../../../path";
import LoaderMain from "../../../layout/header/loader_sub";
import { Link } from "react-router-dom";
import styled, { keyframes } from "styled-components";
function BlogUser(props) {
  const [data, setData] = useState([]);
  const [catData, setCatData] = useState([]);
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );
  const fetchData = () => {
    // Assuming setData, setError, and setLoading are state functions from useState
    setLoading(true);

    fetch(backend + "getblog", {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchCatData = () => {
    // Assuming setData, setError, and setLoading are state functions from useState
    setLoading(true);

    fetch(backend + "getcategorywithsubcategory", {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setCatData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
    fetchCatData();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main class="main" id="main-section">
      <div className="page-header breadcrumb-wrap">
        <div className="container">
          <div className="breadcrumb">
            <a href="/" className="breadcrumb-item d-inline-block" title="Home">
              {" "}
              Home{" "}
            </a>
            <span></span>
            <div className="breadcrumb-item d-inline-block active"> Blogs</div>
          </div>
        </div>
      </div>
      <PageWrapper>
        <HeroSection>
          <HeroContent>
            <HeroBadge>Stories from KeralaSpecials</HeroBadge>
            <HeroTitle>Explore Our Blogs</HeroTitle>
            <HeroSubtitle>
              Dive into curated stories, artisan journeys, and cultural tales
              from the heart of Kerala.
            </HeroSubtitle>
            <Paragraph>
              Discover what makes Kerala special through inspiring narratives
              and insightful guides. Each story is a celebration of tradition,
              craftsmanship, and community spirit.
            </Paragraph>
            <HeroStats>
              <StatCard>
                <StatValue>{data.length || 0}</StatValue>
                <StatLabel>Articles</StatLabel>
              </StatCard>
              <StatCard>
                <StatValue>{catData.length || 0}</StatValue>
                <StatLabel>Categories</StatLabel>
              </StatCard>
            </HeroStats>
          </HeroContent>
          <HeroVisual>
            <HeroImage src="/storage/general/2002.i039.026_smm_modern_promotion_isometric_icons-09.jpg" alt="Blog showcase" />
            <HeroOverlayCard>
              <OverlayTitle>Latest Insights</OverlayTitle>
              <OverlaySubtitle>Stay connected with Kerala’s vibrant culture.</OverlaySubtitle>
            </HeroOverlayCard>
          </HeroVisual>
        </HeroSection>

        <MainContent>
          <BlogSection>
            <SectionHeader>
              <SectionTitle>Featured Stories</SectionTitle>
              <SectionSubtitle>
                Thoughtfully curated articles celebrating Kerala’s unique heritage.
              </SectionSubtitle>
            </SectionHeader>
            <BlogGrid>
              {data?.map((blog, index) => (
                <BlogCard key={blog.blog_id} delay={index * 0.08}>
                  <Link to={`/blog/${blog?.blog_id}`}>
                    <BlogThumbnail>
                      <img
                        src={blogurl + blog?.thumbnail}
                        alt={blog?.title}
                      />
                    </BlogThumbnail>
                  </Link>
                  <BlogContent>
                    <BlogMeta>KeralaSpecial Blogs</BlogMeta>
                    <BlogTitle>
                      <Link to={`/blog/${blog?.blog_id}`}>{blog?.title}</Link>
                    </BlogTitle>
                    <BlogFooter>
                      <ReadMoreLink to={`/blog/${blog?.blog_id}`}>
                        Read Story
                      </ReadMoreLink>
                    </BlogFooter>
                  </BlogContent>
                </BlogCard>
              ))}
            </BlogGrid>
          </BlogSection>

          <Sidebar>
            <SidebarCard>
              <SidebarHeading>Categories</SidebarHeading>
              <CategoryList>
                {catData.map((item, i) => (
                  <CategoryItem key={i} delay={i * 0.05}>
                    <Link to={`/category/${item.category_slug}`}>
                      <div className="category-info">
                        <img
                          data-bb-lazy="true"
                          loading="lazy"
                          src={categoryurl + item.logo}
                          alt={item.category_name}
                        />
                        <span>{item.category_name}</span>
                      </div>
                      <Badge>{item.subcategory.length}</Badge>
                    </Link>
                  </CategoryItem>
                ))}
              </CategoryList>
            </SidebarCard>

            {authenticated?.usertype == 1 && (
              <SidebarCard>
                <SidebarHeading>Popular Tags</SidebarHeading>
                <TagList>
                  {[
                    "Kannadi",
                    "Mundu",
                    "Amadapetti",
                    "Balaramapuram",
                  ].map((tag, i) => (
                    <TagItem key={tag} delay={i * 0.05}>
                      <button type="button" onClick={() => props?.setSearch(tag)}>
                        #{tag}
                      </button>
                    </TagItem>
                  ))}
                </TagList>
              </SidebarCard>
            )}
          </Sidebar>
        </MainContent>

        {loading && <LoaderMain />}
      </PageWrapper>
    </main>
  );
}

export default BlogUser;
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(40px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const fadeInScale = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const floatPulse = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
  100% {
    transform: translateY(0);
  }
`;

const PageWrapper = styled.div`
  max-width: 90vw;
  margin: 0 auto;
  padding: 0 24px 96px;
  display: flex;
  flex-direction: column;
  gap: 80px;
`;

const HeroSection = styled.section`
  margin-top: 60px;
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 36px;
  align-items: center;
  background: linear-gradient(135deg, #fff4e6 0%, #ffffff 60%);
  padding: 48px 56px;
  border-radius: 32px;
  box-shadow: 0 40px 80px rgba(15, 23, 42, 0.08);
  animation: ${fadeInScale} 0.7s ease forwards;

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
    padding: 40px;
  }

  @media screen and (max-width: 640px) {
    padding: 32px 24px;
    margin-top: 40px;
  }
`;

const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: ${fadeInUp} 0.9s ease forwards;
`;

const HeroBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 999px;
  background: rgba(98, 188, 1, 0.16);
  color: #285126;
  font-weight: 600;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  font-size: 12px;
`;

const HeroTitle = styled.h1`
  margin: 0;
  font-size: 48px;
  line-height: 1.1;
  color: #0b1621;

  @media screen and (max-width: 768px) {
    font-size: 36px;
  }
`;

const HeroSubtitle = styled.h3`
  margin: 0;
  font-size: 20px;
  color: #62bc01;
  font-weight: 600;

  @media screen and (max-width: 768px) {
    font-size: 18px;
  }
`;

const Paragraph = styled.p`
  margin: 0;
  color: #354155;
  line-height: 1.7;
  font-size: 16px;

  @media screen and (max-width: 768px) {
    font-size: 15px;
  }
`;

const HeroStats = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 8px;

  @media screen and (max-width: 480px) {
    flex-direction: column;
  }
`;

const StatCard = styled.div`
  background: #ffffff;
  border-radius: 18px;
  padding: 18px 20px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 120px;
`;

const StatValue = styled.span`
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
`;

const StatLabel = styled.span`
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: #6b7280;
`;

const HeroVisual = styled.div`
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  background: #0f1b2b;
  min-height: 360px;
  animation: ${fadeInRight} 0.85s ease forwards;
`;

const HeroImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const HeroOverlayCard = styled.div`
  position: absolute;
  bottom: 24px;
  left: 24px;
  right: 24px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 20px;
  padding: 18px 22px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.25);
  backdrop-filter: blur(6px);
  animation: ${floatPulse} 5s ease-in-out infinite;
`;

const OverlayTitle = styled.h5`
  margin: 0;
  font-size: 16px;
  color: #111827;
  font-weight: 600;
`;

const OverlaySubtitle = styled.p`
  margin: 4px 0 0;
  color: #4b5563;
  font-size: 14px;
`;

const MainContent = styled.div`
  display: grid;
  grid-template-columns: 1.7fr 1fr;
  gap: 32px;

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

const BlogSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const SectionTitle = styled.h2`
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: #0f172a;
`;

const SectionSubtitle = styled.p`
  margin: 0;
  color: #4b5563;
  font-size: 15px;
`;

const BlogGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const BlogCard = styled.article`
  background: #ffffff;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 0;
  transform: translateY(20px);
  opacity: 0;
  animation: ${fadeInUp} 0.8s ease forwards;
  animation-delay: ${({ delay }) => delay}s;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.14);
  }
`;

const BlogThumbnail = styled.div`
  width: 100%;
  height: 220px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;
  }

  ${BlogCard}:hover & img {
    transform: scale(1.05);
  }
`;

const BlogContent = styled.div`
  padding: 24px 26px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const BlogMeta = styled.span`
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 1.6px;
  color: #62bc01;
`;

const BlogTitle = styled.h3`
  margin: 0;
  font-size: 22px;
  line-height: 1.35;
  a {
    color: #111827;
    font-weight: 600;
  }
`;

const BlogFooter = styled.div`
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ReadMoreLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 999px;
  background: #62bc01;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 24px rgba(98, 188, 1, 0.35);
  }
`;

const Sidebar = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

const SidebarCard = styled.div`
  background: #ffffff;
  border-radius: 24px;
  padding: 28px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 18px;
  animation: ${fadeInRight} 0.8s ease forwards;
`;

const SidebarHeading = styled.h4`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: #0f172a;
`;

const CategoryList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const CategoryItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-radius: 16px;
  background: #f8fafc;
  transition: transform 0.2s ease, background 0.2s ease;
  transform: translateY(20px);
  opacity: 0;
  animation: ${fadeInUp} 0.75s ease forwards;
  animation-delay: ${({ delay }) => delay}s;

  &:hover {
    background: #62bc0124;
    transform: translateY(-4px);
  }

  a {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 12px;
    color: #111827;
    font-weight: 500;

    .category-info {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    img {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      object-fit: cover;
    }
  }
`;

const Badge = styled.span`
  min-width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #14532d;
  box-shadow: 0 8px 20px rgba(98, 188, 1, 0.25);
`;

const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const TagItem = styled.div`
  transform: translateY(14px);
  opacity: 0;
  animation: ${fadeInUp} 0.7s ease forwards;
  animation-delay: ${({ delay }) => delay}s;

  button {
    border: none;
    border-radius: 999px;
    padding: 10px 20px;
    background: #111827;
    color: #f9fafb;
    font-weight: 500;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 14px 24px rgba(15, 23, 42, 0.25);
    }
  }
`;
